import {GreenLoanResult} from "../../services/GreenLoanService";
import {Box, Button, LinearProgress, linearProgressClasses, Typography} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import globalTheme from "../../GlobalTheme";
import "./GreenLoanResultComponent.css"

interface Props {
    greenLoanResult: GreenLoanResult
}

export function GreenLoanResultComponent(props: Props) {
    const {
        achievedSavings,
        achievedEnergyMarking,
        achievedEnergySavingsKwh
    } = props.greenLoanResult
    const isApprovedLoan: boolean = achievedSavings >= 30
    let color = isApprovedLoan ? 'success.main' : 'primary'
    return (
        <Box className="box" top="50px">
            <div>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        left: "30%",
                        transform: "translate(-50%)"
                    }}>
                    <Typography sx={{wordWrap: "break-word", maxWidth: "200px"}}>
                        Grense for å kvalifisere til grønt energilån ({30}%)
                    </Typography>
                    <KeyboardArrowDownIcon style={{
                        position: "relative",
                        left: "50%",
                        transform: "translate(-50%)"
                    }}/>
                </div>
                <LinearProgress variant="determinate"
                                value={achievedSavings}
                                sx={{
                                    marginBottom: "30px",
                                    height: 10,
                                    borderRadius: 5,
                                    [`&.${linearProgressClasses.colorPrimary}`]: {
                                        backgroundColor: globalTheme.palette.grey[globalTheme.palette.mode === 'light' ? 200 : 800],
                                    },
                                    [`& .${linearProgressClasses.bar}`]: {
                                        borderRadius: 5,
                                        backgroundColor: color,
                                    },
                                }}
                />
            </div>
            <div style={{display: "flex", columnGap: "40px"}}>
                <div className="information">
                    <Typography fontSize="0.9rem">
                        Besparelse
                    </Typography>
                    <Typography color={color} fontSize="2rem" minWidth="96px" fontWeight="bold"
                                fontFamily="SpareBank1-medium">
                        {achievedSavings} %
                    </Typography>
                </div>
                <div className="information">
                    <Typography fontSize="0.9rem">
                        Forventet Energimerke
                    </Typography>
                    <Typography color={color} fontSize="2rem" fontWeight="bold" fontFamily="SpareBank1-medium">
                        {achievedEnergyMarking}
                    </Typography>
                </div>
            </div>
            <div>
                <Typography fontSize="0.9rem">
                    Estimert oppnådd årlig energibesparelse
                </Typography>
                <Typography color={color} fontSize="2rem" fontWeight="bold" fontFamily="SpareBank1-medium">
                    {achievedEnergySavingsKwh} kWh
                </Typography>
            </div>
            {isApprovedLoan && <Box display="grid">
                <Button variant="contained"
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://www.sparebank1.no/nb/ostlandet/privat/lan/boliglan/gront-boliglan/gront-energilan/sok-gront-energilan.html?cid=partner;;multiconsult;;gront-engergilan;;kalkulator;;sok;;iframe"
                        sx={{marginTop: "10px", textTransform: "none"}}
                        color="success"
                        //onClick={(e) => alert("Call to actions placeholder!")}
                    >
                    Søk grønt energilån
                </Button>
                <Button variant="contained"
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://www.sparebank1.no/nb/ostlandet/privat/kundeservice/bestill/kontakt-meg-om-gronne-lan.html?cid=partner;;multiconsult;;gront-engergilan;;kalkulator;;kontakt;;iframe"
                        sx={{marginTop: "10px", backgroundColor: "#03AC13", textTransform: "none"}}
                        //onClick={(e) => alert("Call to actions placeholder!")}
                    >
                    Kontakt meg om grønt energilån
                </Button>
            </Box>}
        </Box>
    )
}
